var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckmark = function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.47487L4.88909 7.36396L11.253 1",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
export default SvgIconCheckmark;